/**
 * KYC input sanitizers shared across components.
 */

/** PAN: 5 letters + 4 digits + 1 letter (10 chars), uppercase */
export const sanitizePanInput = (raw) => {
    const cleaned = String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    let out = "";
    for (let i = 0; i < cleaned.length && out.length < 10; i++) {
        const c = cleaned[i];
        const pos = out.length;
        if (pos < 5) {
            if (/[A-Z]/.test(c)) out += c;
        } else if (pos < 9) {
            if (/[0-9]/.test(c)) out += c;
        } else if (/[A-Z]/.test(c)) {
            out += c;
        }
    }
    return out;
};

/** IFSC: 4 letters + 0 + 6 alphanumeric (11 chars), uppercase */
export const sanitizeIfscInput = (raw) => {
    const cleaned = String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    let out = "";
    for (let i = 0; i < cleaned.length && out.length < 11; i++) {
        const c = cleaned[i];
        const pos = out.length;
        if (pos < 4) {
            if (/[A-Z]/.test(c)) out += c;
        } else if (pos === 4) {
            if (c === "0") out += c;
        } else if (/[A-Z0-9]/.test(c)) {
            out += c;
        }
    }
    return out;
};

/** Bank account number: digits only, max 16 (min 9 enforced via Yup) */
export const sanitizeAccountNumberInput = (raw) =>
    String(raw || "").replace(/\D/g, "").slice(0, 16);



/** Name: letters and spaces only, max 50 characters */
export const sanitizeNameInput = (raw) => {
    return String(raw || "")
        .replace(/[^A-Za-z ]/g, "")
        .slice(0, 50);
};

